import React from 'react';

/**
 * Bildtext med klickbara hashtaggar och användarnamn.
 *
 * Texten delas upp i stället för att tolkas som HTML — allt som visas är
 * skrivet av användare, och det ska aldrig kunna bli märkup.
 */
const PATTERN = /([#@][\wåäöÅÄÖ-]+)/g;

export default function RichText({ text, onTag, onMention }) {
  if (!text) return null;

  return (
    <>
      {text.split(PATTERN).map((part, index) => {
        if (part.startsWith('#') && onTag) {
          return (
            <button key={index} className="rich-link" onClick={() => onTag(part.slice(1))}>
              {part}
            </button>
          );
        }
        if (part.startsWith('@') && onMention) {
          return (
            <button key={index} className="rich-link" onClick={() => onMention(part.slice(1))}>
              {part}
            </button>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </>
  );
}
